module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-letter-xs-30cc674004dc90a36c757dd009804788.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-letter-xs.png
// module id = 378
// module chunks = 2